import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/Users/wilmerhenao/triduum/t&t/t2t-front/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/Users/wilmerhenao/triduum/t&t/t2t-front/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/Users/wilmerhenao/triduum/t&t/t2t-front/layouts/login.vue").then(m => m.default || m))
}